module.exports = __webpack_public_path__ + "static/media/66860018-onR0wSgs.e034345e.JPG";